<template>
    <div class="available-funds-widget">
        <div class="icon" @click="showModal()">
            <i class="icon-plus"></i>
        </div>

        <div class="text">
            <h6>Available Funds</h6>
            <div class="balance-and-pending">
                <em>$ {{balance}}</em>
                <div v-if="pendingACH" class="pending">
                    <img src="../../assets/img/hourglass.svg" alt="">
                    <span>$ {{pendingACHSum}} Pending</span>
                </div>
                <div class="pending-modal">
                    <img src="../../assets/img/hourglass-blue.svg" alt="">
                    <h3>ACH Pending Transactions</h3>
                    <div class="ach-pending-list">
                        <div v-for="pending of pendingACH" class="ach-pending">
                            <span class="date">{{pending.requestedAt}}</span>
                            <span class="charge"><strong>{{pending.bankAccount}}</strong> for <strong>$ {{pending.amountInUsd}}</strong></span>
                        </div>
                    </div>
                    <p>It can take up to 5 days for ACH transactions to be verified.</p>
                </div>
            </div>
        </div>

        <div v-if="visibleModal" class="tooltip-add-funds">
            <div class="content-tooltip">
                <div class="header-tooltip">Add Funds</div>
                <button @click="hideModal">
                    <i class="fa fa-close"></i>
                </button>
            </div>
            <div v-if="cardsListWidget.length || paymentsAch.length" class="body-tooltip">
                <div class="input-wrapper">
                    <input type="text" min="0" placeholder="Enter $ funds" class="form-control" v-model="funds" @keyup="inputFundsKeyUp()">
                    <p v-if="validationCurrencyInput">Please enter a valid dollar amount. <br />Examples inclide 10, 10.10, 10.1</p>
                    <p v-if="validationCurrencyInputZero">Minimum top up value must be equal or higer than 1.00</p>
                </div>

                <h4 v-if="cardsListWidget.length">From existing Credit card:</h4>

                <div v-if="cardsListWidget.length" class="list-payments list-payments-settings">
                    <div class="credit-cards-list">
                        <div v-for="(card, index) in cardsListWidget" v-bind:key="index" class="credit-card-wrapper">
                            <div class="fts-radio">
                                <input @change="setTypeFlag('CARD')" type="radio" name="payment" v-model="selectedPayment" :id="'cc'+index" :value="'cc-' + card.creditCardId">
                                <label :for="'cc'+index"></label>
                            </div>
                            <label :for="'cc'+index" :class="['credit-card', selectedPayment == 'cc-' + card.creditCardId ? 'selected' : '']">
                                <img class="credit-card-image" :src="require('../../assets/img/' + card.cardImg)" alt="credit-card-logo" />
                                <span class="credit-card-number">... {{card.cardNumber}} </span>
                                <span class="credit-card-nick">{{card.nickName}}</span>
                                <span class="credit-card-default" v-if="card.defcard == '1' && typeAccount != 'HYBRID_TERMS'">Default</span>
                            </label>
                        </div>
                    </div>
                </div>

                <h4 v-if="paymentsAch.length">From Bank Account:</h4>

                <div v-if="paymentsAch.length" class="list-payments list-payments-settings">
                    <div class="credit-cards-list ach-list">
                        <div v-for="(ba, index) in paymentsAch" v-bind:key="index" class="credit-card-wrapper">
                            <div class="fts-radio">
                                <input @change="setTypeFlag('ACH')" type="radio" name="payment" v-model="selectedPayment" :id="'ba'+index" :value="'ba-' + ba.accountId">
                                <label :for="'ba'+index"></label>
                            </div>
                            <label :for="'ba'+index" :class="['credit-card', selectedPayment == 'ba-' + ba.accountId ? 'selected' : '']">
                                <span class="ach-logo">ACH</span>
                                <span class="ach-alias">{{ba.accountAlias}}</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div v-if="typeFlag == 'ACH'" class="ach-warning">
                    <p>It can take up to 5 business days to get payment confirmation from STRIPE. Till then the status of the payment will be pending.</p>
                </div>

                <div class="buttons-wrap">
                    <button class="btn btn-secondary" @click="hideModal">Cancel</button>
                    <button class="btn btn-success" :disabled="validationCurrencyInput || disablePayBtn" @click="addFunds()">Add funds to wallet</button>
                </div>
            </div>

            <div v-else class="body-tooltip">
                <h4>You must add credit card to add funds.</h4>
            </div>
        </div>
    </div>
</template>


<script>
    import Vue from 'vue';
    import Axios from 'axios';
    import globalStore from '../../variables.js';
    import VueSession from "vue-session";
    import VueCookies from 'vue-cookies';
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)
    Vue.use(VueSession);

    export default {
        name: "AvaibleFundWidget",
        data() {
            return {
                cardsListWidget: [],
                paymentsAch: [],
                visibleModal: false,
                typeFlag: false,
                typeAccount: null,
                selectedPayment: '',
                funds: '',
                balance: 0,
                typingTimer: null,
                validationCurrencyInput: false,
                validationCurrencyInputZero: false,
                disablePayBtn: false,
                pendingACH: false,
                pendingACHSum: 0
            }
        },
        methods: {
            absValue() {
                this.funds = Math.abs(this.funds)
            },
            inputFundsKeyDown() {
                clearTimeout(this.typingTimer)
            },
            inputFundsKeyUp() {
                let regEx = /^[1-9]\d*(?:\.\d{0,2})?$/;

                if (this.funds.length > 0) {
                    if (regEx.test(this.funds)) {
                        this.validationCurrencyInput = false;
                        this.validationCurrencyInputZero = false;
                    } else {
                        if (this.funds.startsWith('0')) {
                            this.validationCurrencyInputZero = true;
                            this.validationCurrencyInput = false;
                        } else {
                            this.validationCurrencyInputZero = false;
                            this.validationCurrencyInput = true;
                        }
                    }
                } else {
                    this.validationCurrencyInputZero = false;
                    this.validationCurrencyInputZero = false;
                    this.validationCurrencyInput = false;
                }

            },
            removeCreditCard() {

            },
            getCreditCard() {
                let userLevelId = Number(this.$cookies.get('userLevelId')) ? Number(this.$cookies.get('userLevelId')) : this.$session.get('userLevelId')
                if (userLevelId != 2) {
                    Axios.get(globalStore.data.restApiUrl + '/account/credit-card')
                        .then(response => {
                            this.cardsListWidget = [];
                            let parse = response.data
                            for (let card of parse) {
                                let cardImg = card.card_desc.substring(0, card.card_desc.indexOf('*'));
                                let cardNum = card.card_desc.substring(card.card_desc.indexOf('*') + 5, card.card_desc.length);
                                if (cardImg == 'Visa') {
                                    cardImg = 'Visa-icon.svg'
                                } else if (cardImg == 'MasterCard') {
                                    cardImg = 'MasterCard-icon.svg'
                                } else if (cardImg == 'Discover') {
                                    cardImg = 'Discover-icon.svg'
                                } else if (cardImg == 'JCB') {
                                    cardImg = 'JCB-icon.svg'
                                } else if (cardImg == 'American Express') {
                                    cardImg = 'American Express-icon.svg'
                                } else if (cardImg == 'Diners Club') {
                                    cardImg = 'dinersclub-icon.svg'
                                } else if (cardImg == 'UnionPay') {
                                    cardImg = 'unionpay-icon.svg'
                                } else {
                                    cardImg = 'defaultCard-icon.svg'
                                }

                                this.cardsListWidget.push(
                                    {
                                        creditCardId: card.creditCardId,
                                        cardImg: cardImg,
                                        cardNumber: cardNum,
                                        exp_date: card.exp_date,
                                        defcard: card.defcard,
                                        nickName: card.nickName
                                    }
                                )
                                if (card.defcard == 1 && this.selectedPayment == "") {
                                    this.selectedPayment = 'cc-' + card.creditCardId;
                                    this.typeFlag = 'CARD'
                                }
                            }
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error',
                            text: 'Error Retrieving Credit Card Details - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
                }
            },
            getFunds() {
                let companyId = '';

                if (this.$session.get('companyId')) {
                    companyId = this.$session.get('companyId')
                } else {
                    companyId = this.$cookies.get('companyId');
                }

                Axios.get(`${globalStore.data.restApiUrl}/billing-ng/wallet-info?companyId=${companyId}`)
                    .then( response => {
                        this.balance = response.data.balance;
                        this.balance = this.balance.toFixed(2);
                    })
            },
            addFunds() {
                if (this.selectedPayment == "") {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'No credit card selected',
                        text: this.paymentsAch.length ? 'Please, choose credit card or bank account to add funds' : 'Please, choose credit card to add funds.',
                        duration: 5000,
                    });
                } else if (this.funds < 1) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Funds amount is too small',
                        text: 'You need to add at least $1.00.',
                        duration: 5000,
                    });
                } else {
                    if (this.typeFlag == 'CARD') {
                        this.payByCC()
                    } else if (this.typeFlag == 'ACH') {
                        this.payByAch()
                    }
                }
            },
            getPayment() {
                Axios.get(`${globalStore.data.restApiUrl}/ach-payments`)
                    .then(response => {
                        this.paymentsAch = []
                        for (let ach of response.data) {
                            if (ach.accountStatus == 'VERIFIED') {
                                this.paymentsAch.push(ach)
                            }
                        }
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Wrong getting payment',
                            text: 'Something was wrong during getting payment methods. Please contact with support.',
                            duration: 5000,
                        });
                        console.log(error)
                        return false
                    })
            },
            getPendingACH() {
                let companyId = '';

                if (this.$session.get('companyId')) {
                    companyId = '';
                } else {
                    companyId = '?companyId=' + this.$cookies.get('companyId');
                }
                Axios.get(globalStore.data.restApiUrl + '/ach-payments/pending-charges' + companyId)
                    .then(response => {
                        this.pendingACHSum = 0
                        if (response.data.length != 0) {
                            this.pendingACH = response.data
                            for (let pending of this.pendingACH) {
                                this.pendingACHSum += pending.amountInUsd
                                pending.amountInUsd = pending.amountInUsd.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }
                            this.pendingACHSum = this.pendingACHSum.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        } else {
                            this.pendingACH = false
                        }
                    })
            },
            showModal() {
                this.getCreditCard()
                this.visibleModal = true;
                if (this.selectedPayment.indexOf('ba') > -1) {
                    this.typeFlag = 'ACH'
                } else if (this.selectedPayment.indexOf('cc') > -1) {
                    this.typeFlag = 'CARD'
                } else {
                    this.typeFlag = false
                }
            },
            hideModal() {
                this.visibleModal = false
            },
            setTypeFlag(flag) {
                this.typeFlag = flag
            },
            payByCC() {
                this.disablePayBtn = true
                let dataToSend = {
                    ccId: this.selectedPayment.substr(3,this.selectedPayment.length),
                    amount: this.funds
                }

                let companyId = '';

                if (this.$session.get('companyId')) {
                    companyId = this.$session.get('companyId');
                } else {
                    companyId = this.$cookies.get('companyId');
                }

                Axios.post(`${globalStore.data.restApiUrl}/billing-pricing/top-up?companyId=${companyId}`, dataToSend)
                    .then(response => {
                        if (response.status == 200) {
                            this.hideModal()
                            setTimeout(() => {
                                this.disablePayBtn = false
                            }, 5000)
                            let timeout = setTimeout(() => {
                                this.getFunds()
                            }, 5000)
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Adding funds ordered',
                                text: 'Your wallet will be updated soon.',
                                duration: 5000,
                            });
                        }
                    })
                    .catch( error => {
                        setTimeout(() => {
                            this.disablePayBtn = false
                        }, 5000)

                        if (error.response.data.errors[0].errorCode == 'ResourceThresholdReachedExeption') {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: error.response.data.errors[0].errorMessage,
                                text: error.response.data.errors[0].details,
                                duration: 5000
                            })
                        }

                        if (error.response.status != 429) {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Error',
                                text: 'Something went wrong during ordering of adding funds. Please contact support.',
                                duration: 5000,
                            });
                        }
                        console.log(error)
                    })
            },
            payByAch() {
                this.disablePayBtn = true
                let amountCents = Number(this.funds) * 100;

                let chargeData = {
                    bankAccountId: this.selectedPayment.substr(3,this.selectedPayment.length),
                    amountInCents: amountCents
                }

                Axios.post(`${globalStore.data.restApiUrl}/ach-payments/charge`, chargeData)
                    .then(response => {
                        this.hideModal()
                        let timeout = setTimeout(() => {
                            this.getFunds()
                            this.getPendingACH()
                            setTimeout(() => {
                                this.disablePayBtn = false
                            }, 5000)
                        }, 5000)
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Adding funds ordered',
                            text: 'Your wallet will be updated soon.',
                            duration: 5000,
                        });
                    }).catch(error => {
                        setTimeout(() => {
                            this.disablePayBtn = false
                        }, 5000)
                        if (error.response.data.errors.length > 0) {
                            error.response.data.errors.forEach(error => {
                                if (error.errorCode == 'SimonPaymentException') {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Wrong payment bank account',
                                        text: error.errorMessage,
                                        duration: 5000,
                                    });
                                    return false
                                } else if (error.errorCode == 'ResourceThresholdReachedExeption') {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: error.response.data.errors[0].errorMessage,
                                        text: error.response.data.errors[0].details,
                                        duration: 5000
                                    })
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Wrong payment bank account',
                                        text: 'Something was wrong during payment bank account. Please contact with support.',
                                        duration: 5000,
                                    });
                                    return false
                                }
                            })
                        }
                })
            }
        },
        mounted() {
            this.getCreditCard();
            this.getFunds();
            if (this.$session.get('token')) {
                this.typeAccount = this.$session.get('typeAccount')
            } else {
                this.typeAccount = this.$cookies.get('typeAccount')
            }
            if (this.typeAccount == 'HYBRID_TERMS') {
                this.getPayment()
                this.getPendingACH()
            }

            globalStore.data.EventBus.$on('refreshTopUpWidget', () => {
                this.getCreditCard();
                if (this.typeAccount == 'HYBRID_TERMS') {
                    this.getPayment()
                }
            });
        }
    };
</script>


<style lang="scss">
    @import "../../assets/scss/_variables.scss";
    @import "../../assets/scss/_mixins.scss";

    .available-funds-widget {
        color: $white;
        display: flex;
        justify-content: space-between;
        margin-left: 30px;
        padding-top: 9px;
        position: relative;
        .icon {
            width: 34px;
            height: 34px;
            padding: 8px;
            border-radius: 5px;
            margin-right: 10px;
            background-color: #0088FF;
            @include boxSizing;
            cursor: pointer;

            .icon-plus {
                display: block;
                text-align: center;
                line-height: 19px;
                &::before {
                    font-size: 17px;
                }
            }
        }

        .text {
            display: flex;
            flex-direction: column;
            h6 {
                margin: 0;
                font-size: 12px;
                color: #23282c;
                font-weight: 400;
            }
            .balance-and-pending {
                position: relative;
                display: flex;
                align-items: center;
                em {
                    font-size: 14px;
                    line-height: 13px;
                    color: #0088FF;
                    font-style: normal;
                    font-weight: 700;
                }
                .pending-modal {
                    position: absolute;
                    top: 31px;
                    left: 0;
                    display: none;
                    flex-direction: column;
                    align-items: center;
                    width: 500px;
                    padding: 20px;
                    background-color: #fff;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    color: #515B65;
                    h3 {
                        margin: 0 0 20px;
                        font-size: 15px;
                        color: #2F353A;
                        font-weight: 700;
                    }
                    .ach-pending-list {
                        width: 100%;
                        .ach-pending {
                            display: flex;
                            flex-direction: column;
                            margin: 0 0 20px;
                            &:last-child {
                                margin: 0 0 24px;
                            }
                        }
                    }
                    p {
                        margin: 0;
                        text-align: center;
                    }
                }
                .pending {
                    display: flex;
                    align-items: center;
                    padding: 0 2px;
                    margin: 0 0 0 12px;
                    color: #000;
                    background-color: #e3f2ff;
                    border: 1px solid #73bdff;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    img {
                        margin: 0 6px 0 0;
                    }
                    &:hover {
                        &+.pending-modal {
                            display: flex;
                        }
                    }
                }
            }
        }

        .tooltip-add-funds {
            position: absolute;
            top: 0;
            min-width: 340px;
            left: 42px;
            min-width: 340px;
            background-color: #fff;
            border-radius: 10px;
            color: #000;
            border: 1px solid #C9CFD4;

            .content-tooltip {
                display: flex;
                justify-content: space-between;
                padding: 10px;
                font-weight: 700;

                button {
                    border: 0;
                    background-color: transparent;

                    i {
                        margin-right: 0;
                    }
                }
            }

            .body-tooltip {
                padding: 10px;

                .input-wrapper {
                    input {
                        max-width: 120px;
                        margin-bottom: 20px;
                        background-color: #F0F3F5;
                        border: 1px solid #C9CFD4;
                    }

                }

                h4 {
                    display: block;
                    font-size: 14px;
                    margin-bottom: 20px;
                    font-weight: 400;
                }

                .credit-card-wrapper {
                    margin-bottom: 10px;
                    cursor: pointer;
                    &:last-child {
                        margin-bottom: 14px;
                    }
                    .fts-radio {
                        margin: 0 10px 0 0;
                    }
                }
                .ach-warning {
                    padding: 10px;
                    margin-bottom: 20px;
                    background-color: #ffe3e3;
                    border: 1px solid #FC4D4D;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    p {
                        margin: 0;
                        font-size: 12px;
                        line-height: 20px;
                    }
                }
            }
            .buttons-wrap {
                display: flex;
                justify-content: center;
                margin-bottom: 8px;

                button {
                    margin: 0 5px;
                }
            }
        }

        .credit-cards-list {
            display: flex;
            flex-direction: column;
            margin-bottom: 0;

            .credit-card-wrapper {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .remove-button {
                    height: 36px;
                    width: 36px;
                    margin-left: 8px;
                    box-sizing: border-box;
                    text-align: center;
                    line-height: 34px;
                    border: 1px solid #C9CFD4;
                    -webkit-box-shadow: 0px 0px 6px 3px rgba(213,218,221,1);
                    -moz-box-shadow: 0px 0px 6px 3px rgba(213,218,221,1);
                    box-shadow: 0px 0px 6px 3px rgba(213,218,221,1);
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    cursor: pointer;
                }
            }

            .credit-card {
                display: flex;
                align-items: center;
                width: 340px;
                margin-bottom: 0;
                padding: 6px 12px 6px 8px;
                border: 0;
                background-color: #edeff1;
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                cursor: pointer;

                &:hover {
                    -webkit-box-shadow: none;
                    -moz-box-shadow: none;
                    box-shadow: none;
                    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                }

                &.selected {
                    color: #fff;
                    border-color: #0088FF;
                    background-color: #0088FF;
                    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    -moz-box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                    box-shadow: 0px 0px 0px 1px rgba(0,136,255,1);
                }

                .ach-logo {
                    padding: 6px 8px;
                    margin-right: 10px;
                    display: inline-block;
                    background-color: #00C4B0;
                    border-radius: 4px;
                    font-size: 11px;
                    line-height: 13px;
                    font-weight: 700;
                    color: #fff;
                }

                .credit-card-image {
                    margin-right: 11px;
                }

                .credit-card-number {
                    margin-right: 20px;
                }

                span:last-child {
                    flex-grow: 1;
                    text-align: right;
                }
            }
        }
    }

    .dark-theme {
        .available-funds-widget {
            .text {
                h6 {
                    color: #fff;
                }
                .balance-and-pending {
                    .pending {
                        span {
                            color: #000 !important;
                        }
                    }
                    .pending-modal {
                        background-color: #3a4149;
                        border-color: #1a1c1d;
                        color: #fff;
                        h3 {
                            color: #fff;
                        }
                    }
                }
            }
            .tooltip-add-funds {
                background-color: #3a4149;
                border-color: #1a1c1d;
                color: #fff;
                .body-tooltip {
                    .input-wrapper {
                        input {
                            color: #fff;
                            background-color: #515b65;
                            border-color: #1a1c1d;
                            &::placeholder {
                                color: #fff;
                            }
                        }
                    }
                    .credit-cards-list {
                        .credit-card {
                            background-color: #515b65;
                            &.selected {
                                background-color: #0088ff;
                            }
                        }
                    }
                    .ach-warning {
                        background-color: #6b3d3d;
                        color: #fff;
                    }
                }
            }
        }
    }
</style>
